import { Link } from 'react-router-dom';
import { To } from 'history';

// material-ui
import { Box } from '@mui/material';
import { SxProps } from '@mui/system';
import { useTheme } from '@mui/material/styles';

// project imports
import { APP_DEFAULT_PATH } from 'config';
import usePrivateKey from 'hooks/usePrivateKey';

// Assets
import hilconaMob from '../../assets/images/mob-image/hilcona_mob_size.png';
import repowerMob from '../../assets/images/mob-image/repower-mob_size.ico';
import iomarketMob from '../../assets/images/mob-image/favi.svg';
import lindenhofgruppeMob from '../../assets/images/mob-image/lindenhofgruppe_mob.png';

const profileData = localStorage.getItem('instanceName');

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

const LogoSection = ({ isIcon, sx, to }: Props) => {
  const theme = useTheme();
  const { isIOMDomain } = usePrivateKey();

  const profileImages: Record<string, string> = {
    hilcona: hilconaMob,
    repower: repowerMob,
    'io-market': iomarketMob,
    lindenhofgruppe: lindenhofgruppeMob
  };

  // Remove HTML entities and quotes
  const cleanPath = (value: string | null): string => {
    return (value || '')
      .replace(/&quot;/g, '')
      .replace(/^"+|"+$/g, '')
      .trim();
  };

  const logoImage = cleanPath(localStorage.getItem('logoImage'));
  const whiteLogoImage = cleanPath(localStorage.getItem('whiteLogoImage'));

  const baseUrl =
    process.env.REACT_APP_IMAGE_URL ||
    'https://portal.netgate.io-procurement.com/';

  const MobImg = profileImages[profileData || ''] || iomarketMob;

  const buildUrl = (path: string) => {
    if (!path) return '';

    // Already a full URL
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }

    return `${baseUrl.replace(/\/$/, '')}/${path.replace(/^\/+/, '')}`;
  };

  const logoSrc = isIOMDomain
    ? theme.palette.mode === 'dark'
      ? whiteLogoImage
      : logoImage
    : buildUrl(
        theme.palette.mode === 'dark'
          ? whiteLogoImage
          : logoImage
      );

  console.log('logoImage:', logoImage);
  console.log('whiteLogoImage:', whiteLogoImage);
  console.log('logoSrc:', logoSrc);

  return (
    <Box
      component={Link}
      to={to || APP_DEFAULT_PATH}
      sx={isIcon ? sx : { padding: '15px 10px 0px 40px' }}
    >
      {isIcon ? (
        <img height={28} src={MobImg} alt="Logo" />
      ) : (
        <img
          src={logoSrc}
          alt="Logo"
          height="80%"
          width="80%"
        />
      )}
    </Box>
  );
};

export default LogoSection;